module.exports = __webpack_public_path__ + "static/col-3-629a733a15f8c24d57bc88f17d1863a8.svg";